import Button from "componentsTemplate/Button/Button";
import { useEffect, useState } from "react";
import { AiOutlineReload } from "react-icons/ai";
import { FaRegCopy, FaSpinner } from "react-icons/fa";
import { MdOutlineQrCode, MdPix } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import { getPaymentPix } from "services/MercadoPagoService";
import { showToastError, showToastSuccess } from "utils/toasts";

const MethodPixPayment: React.FC<any> = ({
  pixResponse,
  setPixResponse,
  planSelected,
  methodPayment,
}) => {

  const [loading, setLoading] = useState(false);
  
  const fetchPix = async () => {

    setLoading(true);

    const data = {
      plan_id: planSelected.id,
    }

    try {
      const response = await getPaymentPix(data);

      if (response.status == "pending") {
        setPixResponse(response.response);
      } else {
        showToastError('Erro ao gerar QR Code Pix!');
      }
      
    } catch (error) {
      showToastError('Erro ao gerar QR Code Pix!');
    } finally {
      setLoading(false);
    }
  }

  const handleCopyPixCode = () => {
    if (!pixResponse?.point_of_interaction?.transaction_data?.qr_code) {
      showToastError('Código pix não encontrado!');
      return;
    }
    navigator.clipboard.writeText(pixResponse?.point_of_interaction?.transaction_data?.qr_code);
    showToastSuccess('Código pix copiado com sucesso!');
  }

  const getFormatedPrice = (price: number) => {

    if (!price) return 'R$ -,--';

    const formatter = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });

    return formatter.format(price);
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-10">
      <div className="col-span-1 md:col-span-2 gap-6">

        <div className="flex justify-center">
          <div className="p-[10px] bg-gray-100 rounded-lg border border-gray-200 shadow-lg">
            {
              (pixResponse) ? (
                <img className="w-[250px] h-[250px] max-w-[250px] max-h-[250px]" src={`data:image/png;base64,${pixResponse?.point_of_interaction?.transaction_data?.qr_code_base64}`} alt="QR Code Pix" />
              ) : (
                <div className="w-[250px] h-[250px] max-w-[250px] max-h-[250px] flex items-center justify-center">
                  {
                    loading ? (
                      <div className="flex items-center justify-center rounded-full h-32 w-32 bg-gray-200 text-primary-600 cursor-wait shadow-md">
                        <AiOutlineReload className="animate-spin" size={75} />
                      </div>
                    ) : (
                      <div className="
                        flex items-center justify-center rounded-full h-32 w-32 bg-gray-200 text-primary-600 cursor-pointer shadow-md
                        hover:rotate-45 transition-transform duration-500"
                        onClick={fetchPix}
                      >
                        <AiOutlineReload size={75} />
                      </div>
                    )
                  }
                </div>
              )
            }
          </div>
        </div>

        <div className="flex justify-center mt-4">
          {
            (pixResponse) ? (
              <div>
                <Button
                  pattern = "third"
                  className="me-4"
                  type="button"
                  onClick={() => setPixResponse(null)}
                >
                  Cancelar
                </Button>

                <Button
                  pattern="primary"
                  className="mt-4"
                  onClick={() => handleCopyPixCode()}
                >
                  Copiar código Pix
                  <FaRegCopy className="ms-2" size={22} />
                </Button>
              </div>
            ) : (
              <>
                {
                  loading ? (
                    <Button
                      pattern="primary"
                      className="mt-4"
                      disabled
                    >
                      Gerando Pix
                      <FaSpinner className="ms-2 animate-spin" size={22} />
                    </Button>
                  ) : (
                    <Button
                      pattern="primary"
                      className="mt-4"
                      onClick={fetchPix}
                    >
                      Gerar QR Code
                      <MdOutlineQrCode className="ms-2" size={22}/>
                    </Button>
                  )
                }
              </>
            )
          }
        </div>

      </div> 

      <div className="col-span-1 border rounded-lg flex flex-col">
        <div className="p-1 font-semibold text-lg">
          Resumo do Pedido
        </div>

        <hr />

        <div className="flex-grow p-1">
          <p className="text-gray-400 text-xs">Itens do pedido</p>
          <div className="ms-1 text-gray-600 mt-1">Plano {planSelected.name ?? '-'}</div>

          <p className="text-gray-400 text-xs mt-3">Forma de pagamento</p>
          <div className="ms-1 flex mt-1">
            <MdPix className="text-gray-600" size={22}/>
            <div className="ml-2 text-gray-600">PIX</div>
          </div>
        </div>

        <hr />

        <div className="p-1">
          <div className="text-gray-400 text-sm md:text-md">
            1x de {getFormatedPrice(planSelected.price)}
          </div>
          <div className="text-gray-600 flex justify-between mt-1">
            <div className="text-sm md:text-md">
              Total a pagar:
            </div>
            <div className="font-bold text-md md:text-xl">
              {getFormatedPrice(planSelected.price)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MethodPixPayment;
